(function() {
	angular.module('ShargoApp')
		.service('DriverRegisterService', function($http, Configuration) {
			var svc = {};

			svc.getStatus = function(token) {
				return $http.get(Configuration.apiUrl + "/drivers/form/register?registerToken=" + token);
			};

			svc.sendForm = function(token, data) {
				var params = {
					registerToken: token,
					nif: data.nif,
					bancAccountNumber: data.number,
					bancAccountOwner: data.name,
					password: data.pass,
					email: data.email
				};
				var i = params.bancAccountNumber.indexOf(" ");
				while (i > -1){
					params.bancAccountNumber = params.bancAccountNumber.slice(0, i) + params.bancAccountNumber.slice(i + 1);
					i = params.bancAccountNumber.indexOf(" ");
				}
				return $http.post(Configuration.apiUrl + '/drivers/form/register', params);
			};

			return svc;
		})

		.controller('DriverRegisterController', function($rootScope, $scope, $routeParams, $location, toolsService, DriverRegisterService, Configuration){
			$rootScope.pageConfiguration = {
				footer: false,
				header: {
					solid: -1000,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: false,
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: false,
					dashboard: false,
					callToAction: {
						link: false,
						text: '',
						target: '_self',
						hide: false,
						disabled: false
					},
					profile: false
				}
			};

			$scope.isLoading = true;
			$scope.showForm = true;
			$scope.success = true;
			$scope.check = {};
			$scope.data = {
				nif: "",
				name: "",
				number: "",
				pass: "",
				againPass: "",
				email: "",
				staticname: "",
				image: ""
			};

			DriverRegisterService.getStatus($routeParams.token)
				.then(function (response) {
					console.log("SUCCESS", response);
					$scope.isLoading = false;
					$scope.data.email = response.data.email;
					$scope.data.staticname = response.data.firstName + " " + response.data.lastName;
					$scope.data.image = response.data.imageUrl;
				})
				.catch(function (data) {
					console.log("ERROR", data);
					$scope.isLoading = false;
					if (data.status == 400 && $routeParams.token) {
						$scope.showForm = false;
						$scope.success = false;
					}
					else {
						$location.path($rootScope.url('notfound'));
					}
				});

			$scope.submit = submit;
			
			function submit() {
				if (!$scope.data.nif || $scope.data.nif.length < 8){
					$scope.check.nif = "driver-register.error.nif";
				}
				if (!$scope.data.name) {
					$scope.check.name = "driver-register.error.name";
				}
				if (!$scope.data.number || !IBAN.isValid($scope.data.number)){
					$scope.check.number = "driver-register.error.number";
				}
				if (!$scope.data.pass || $scope.data.pass.length < 6){
					$scope.check.pass = "driver-register.error.pass"
				}
				if ($scope.data.pass !== $scope.data.againPass){
					$scope.check.pass = "driver-register.error.pass-not-match";
				}
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (!$scope.data.email || !re.test($scope.data.email)) {
					$scope.check.email = "driver-register.error.email";
				}
				if (!toolsService.allFalse($scope.check)) {
					console.log("SEND FORM");
					DriverRegisterService.sendForm($routeParams.token, $scope.data)
						.then(function (data) {
							console.log("SUCCES SEND FORM", data);
							$scope.showForm = false;
						})
						.catch(function (error) {
							console.log("ERROR IN SEND FORM", error);
							if (!error.data) {
								$scope.check.nif = "common.fatal-error";
							}
							else if (error.status == 403) {
								$scope.check.email = "driver-register.error.email-used";
							}
							else {
								$scope.check.email = error.data.message.message;
							}
						});
				}
			}
		});
})();